module.exports = __webpack_public_path__ + "static/media/TreySeniorPhoto2-bigfile.9de84300.jpg";